import React from "react";
import MedicoParceiroSteps from "./steps/MedicoParceiroSteps";
import { MedicoParceiroStoreProvider } from '../../../context/MedicoParceiroContext';

export default function CorpoClinico() {

    return (
        <MedicoParceiroStoreProvider>
            <MedicoParceiroSteps />
        </MedicoParceiroStoreProvider>
    )

}